<template>
    <li
        v-if="isNavHorizontal"
        data-top-right-id="notifications"
        class="wrapper"
        @click="$emit('toggle')"
    >
        <a class="nav-link">
            <i class="fas fa-bell"></i>
            <span class="d-lg-none">Notification</span>
            <div
                v-show="count > 0"
                :class="['badge', { 'enhanced-layout': isEnhancedLayout }]"
            >
                {{ count > 99 ? "99+" : count }}
            </div>
        </a>
    </li>

    <li
        v-else
        class="left-option"
        data-top-right-id="notifications"
        @click="$emit('toggle-drawer')"
    >
        <button>
            <i class="fas fa-bell"></i>
            <span>Notification</span>
            <span v-show="count > 0" class="badge">
                {{ count > 99 ? "99+" : count }}
            </span>
        </button>
    </li>
</template>

<script>
export default {
    props: {
        isNavHorizontal: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        count() {
            return this.$store.state?.notification?.count ?? 0;
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    watch: {
        count(value) {
            let label = value > 99 ? "99+" : value;

            const removeNumberFromTitle = () => {
                document.title = document.title.replace(/\(.*?\)\s*/, "");
            };

            if (value > 0) {
                removeNumberFromTitle();
                document.title = "(" + label + ") " + document.title;
            } else {
                removeNumberFromTitle();
            }
        }
    },
    mounted() {
        this.$root.$on("settingLoaded", () => {
            this.$store.dispatch("notification/getNotificationCount");
        });
    }
};
</script>

<style lang="scss" scoped>
.wrapper {
    position: relative;
    cursor: pointer;
}

.badge {
    transition: none;
    background: red;
    position: absolute;
    top: -3px;
    right: 0;
    font-size: 0.7em;

    &.enhanced-layout {
        color: white;
    }
}

.left-option {
    width: 100%;

    button {
        display: flex;
        gap: 10px;
        height: 36px;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        border-radius: 4px;

        border: 0;
        outline: 0;
        background: transparent;
        width: 100%;
        color: white;
        font-weight: 500;

        &:focus-visible {
            box-shadow: 0 0 0 0 #fff, 0 0 0 2px rgba(59, 130, 246, 0.5),
                0 0 #0000;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }
    }

    .badge {
        position: relative;
        top: 0;
    }
}
</style>
